import type { CRMState } from './types';

/**
 * What a CRM write says of itself (relecture du 13/10/2026). The slices keep a failure in the
 * store's shared `error` (their contract); a write also RETURNS its own, so a screen judges the
 * gesture on its result — never on `error`, which the list read again after it, or Realtime's
 * reload, may set meanwhile.
 */

/** A failure as a sentence: an Error's or a Postgrest error's message, else the fallback. */
export function messageOf(error: unknown, fallback: string): string {
  if (error instanceof Error) return error.message;
  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') return error.message;
  return fallback;
}

/** A write's own failure: kept in the store's `error` and returned to the gesture. */
export function failed(set: (partial: Partial<CRMState>) => void, error: unknown, fallback: string, extra: Partial<CRMState> = {}): string {
  const message = messageOf(error, fallback);
  set({ error: message, ...extra });
  return message;
}

/**
 * A write aimed at ONE row by its id: its error, or no row touched — gone meanwhile, or refused by
 * the row rules (which answer without an error) — said rather than taken for a success.
 */
export async function oneRow(query: PromiseLike<{ data: unknown[] | null; error: { message: string } | null }>, what: string): Promise<void> {
  const { data, error } = await query;
  if (error) throw new Error(error.message);
  if (!data || data.length === 0) throw new Error(`${what} n'a pas été modifié (supprimé entre-temps, ou modification refusée).`);
}
